import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  accessibleClients: [],
  loading: false,
};

const transferModule = {
  state,
  mutations,
  actions,
  getters,
};

export default transferModule;
